import { Check } from 'lucide-react';

const PROMISES = [
  "Phone number visible only to profiles you've accepted",
  '100% mobile-verified and no fake profiles',
  'Your data is safe with us',
  //'Photo blur control, you decide who sees your photo',
  'Block or report any profile instantly',
  'Conversations stay private to the chat',
] as const;

const STATS = [
  { value: '100%', label: 'Verified profiles' },
  { value: '37 Yrs', label: 'Trusted since 1990' },
  { value: '100%', label: 'Data safety' },
] as const;

export default function HomePrivacySection() {
  return (
    <section className="relative overflow-hidden bg-[#f6f6f4] font-sans">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 right-0 hidden w-[min(46%,460px)] bg-contain bg-right bg-no-repeat lg:block"
        style={{ backgroundImage: "url('/assets/img/banana-tree.png')" }}
      />

      <div className="relative z-10 mx-auto w-full max-w-[1120px] px-5 py-16 md:px-8 md:py-20">
        <div className="text-center">
          <p className="text-[13px] font-semibold uppercase tracking-[2px] text-black">Privacy, made simple</p>
          <h2 className="mx-auto mt-2 max-w-[12ch] text-[28px] font-bold leading-tight text-black md:max-w-none md:text-[40px]">
            Your privacy in your control
          </h2>
          <p className="mt-3 text-[15px] text-neutral-600 md:text-[16px]">Five clear promises. No fine print.</p>
        </div>

        <div className="mt-10 grid items-center gap-10 lg:mt-14 lg:grid-cols-[minmax(0,1.15fr)_minmax(240px,0.7fr)] lg:gap-16">
          <ul className="order-2 divide-y divide-neutral-200 lg:order-1">
            {PROMISES.map((promise) => (
              <li key={promise} className="flex items-start gap-3 py-4">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#22a85a] text-white">
                  <Check className="h-3 w-3" strokeWidth={3} aria-hidden />
                </span>
                <p className="text-[16px] font-medium leading-snug text-black">{promise}</p>
              </li>
            ))}
          </ul>

          <div className="order-1 flex flex-col items-center gap-8 text-center lg:order-2 lg:gap-10">
            {STATS.map((stat) => (
              <div key={stat.label}>
                <p className="text-[40px] font-black leading-none tracking-[-0.03em] text-black md:text-[48px]">
                  {stat.value}
                </p>
                <p className="mt-2 text-[14px] text-neutral-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
